import { Controller } from "@hotwired/stimulus"

const stateLabels = {
  neutral: "No preference",
  focus: "Focus",
  avoid: "Avoid"
}

export default class extends Controller {
  static targets = ["region", "state"]

  connect() {
    this.render()
  }

  cycle(event) {
    const region = event.currentTarget.dataset.region
    const select = this.stateTargets.find((target) => target.dataset.region === region)
    const states = ["neutral", "focus", "avoid"]
    select.value = states[(states.indexOf(select.value) + 1) % states.length]
    this.render()
  }

  keyboardCycle(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      this.cycle(event)
    }
  }

  render() {
    this.regionTargets.forEach((region) => {
      const state = this.stateTargets.find((target) => target.dataset.region === region.dataset.region)?.value || "neutral"
      const style = {
        neutral: { fill: "transparent", fillOpacity: "0", stroke: "transparent" },
        focus: { fill: "#6b8e68", fillOpacity: "0.28", stroke: "#6b8e68" },
        avoid: { fill: "#c9534f", fillOpacity: "0.28", stroke: "#c9534f" }
      }[state]

      region.setAttribute("fill", style.fill)
      region.setAttribute("fill-opacity", style.fillOpacity)
      region.setAttribute("stroke", style.stroke)
      region.setAttribute("aria-label", `${region.dataset.label}: ${stateLabels[state]}`)
    })
  }
}
